import style from '@/pages/layout/style/FrontLayout.module.less';
import { Breadcrumb as Bread, Button } from 'antd';
import { EnvironmentOutlined } from '@ant-design/icons';
import {useRouter, useUserInfo} from '@/hooks/hooks';
import { matchRoutes, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import frontRouter from '@/pages/front/router';

const routerBreadcrumbMap: Record<string, string> = {
  'front': '首页',
  'school': '校务管理',
  'template': '报告分析模板',
  'addTemplate': '新增模板',
  'editTemplate': '修改模板',
  'personnel': '人员管理',
  'examCenter': '考试分析',
  'examCenterImport': '考试分析',
  'examAdd': '创建考试',
  'examEdit': '编辑',
  'importHistory': '导入历史记录',
  'eduUser': '教研室人员',
  'importEduUser': '导入教研室人员',
  'importTeacherUser': '导入教师',
  'importClass': '导入班级',
  'importStudentUser': '导入学生',
  'import': '导入',
  'reportSetting': '报告设置',
  'examAbsence': '缺考/标记学生名单',
  'schoolDimension': '学校维度查看',
  'modifyScore': '修改成绩',
  'modifyHistory': '修改记录',
  'publish': '发布报告设置',
  'schoolImportedPreview': '各校导入概览',
  'detail': '详情',
  'apply': '标记学生申请',
  'applyReview': '标记学生申请审核',
  'batchimportscore': '批量上传小题得分',
  'permission': '权限管理',
  'permissionMember': '人员清单',
  'addPerTree': '添加角色',
  'editPerTree': '修改角色',
  'preMark': '缺考登记'
};

interface BreadProps {
  path: string;
  name: string;
}

const getPath = (arr: string[], index: number) => {
  const a: string[] = [];
  arr.forEach((item, i) => {
    i <= index && a.push(item);
  });
  return '/' + a.join('/');
};

const searchParamsCache: Record<string, string> = JSON.parse(localStorage.getItem('Breadcrumb') || '{}');

const setCache = () => {
  localStorage.setItem('Breadcrumb', JSON.stringify(searchParamsCache));
};

const getCache: () => Record<string, string> = () => {
  return JSON.parse(localStorage.getItem('Breadcrumb') || '{}');
};

const Breadcrumb = () => {

  const router = useRouter();
  const location = useLocation();
  const [arr, setArr] = useState<BreadProps[]>([]);
  const userState = useUserInfo();
  const { backbtn } = router.getSearchParams();
  useEffect(() => {
    const pathArr = location.pathname.split('/').filter(i => i);
    const routerName = matchRoutes(frontRouter, location.pathname)?.pop()?.route.path;
    routerName && (searchParamsCache[routerName] = location.search);
    setCache();

    const a = pathArr.map((i, index) => {
      let path = getPath(pathArr, index);
      const r = matchRoutes(frontRouter, path)?.pop()?.route.path;
      if (r) {
        path += getCache()[r] || '';
      }
      if (routerBreadcrumbMap[i]) {
        return {
          path,
          name: routerBreadcrumbMap[i]
        };
      } else {
        const s = router.decodeParams(i);
        return {
          path,
          name: s.split('+')[1]
        };
      }
    });
    setArr(a);
  }, [location]);

  const clickDisable = (name: string) => {
    if (name === '学校维度查看' ||
      userState.userType === 'TEACHER' && name === '缺考/标记学生名单' ||
      name === '导入历史记录'
    ) {
      return true;
    }
    return false;
  };

  const routerChange = (i: BreadProps) => {
    if (!clickDisable(i.name) && matchRoutes(frontRouter, i.path)) {
      router.to(i.path);
    }
    return !clickDisable(i.name) && matchRoutes(frontRouter, i.path);
  };

  const back = () => {
    // router.back();
    const l = arr.length - 2;
    if (l < 0) return false;
    const f = routerChange(arr[l]);
    if (!f) routerChange(arr[l - 1]);
  };

  return (
    <div className={style.frontBread}>
      <div>
        <span className={style.frontBreadItem}>
          <EnvironmentOutlined />
          当前位置：
        </span>
        <Bread separator=">">
          {
            arr.map((i) => {
              return <Bread.Item
                onClick={() => routerChange(i)}
                key={i.path}
                className={style.breadName}
              >
                {i.name}
              </Bread.Item>;
            })
          }
        </Bread>
      </div>
      {
        backbtn !== 'false' && <Button onClick={back}>返回</Button>
      }
    </div>
  );
};

export default Breadcrumb;
